var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_8_Movie_story",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12h5v22c0 .553.448 1 1 1s1-.447 1-1V12h1c.552 0 1-.447 1-1s-.448-1-1-1H8V7c0-2.757 2.243-5 5-5h31.111c-1.3 1.272-2.111 3.042-2.111 5v3H24c-.552 0-1 .447-1 1s.448 1 1 1h24c.553 0 1-.447 1-1v-4c0-2.757 2.243-5 5-5s5 2.243 5 5v15c0 .553.447 1 1 1s1-.447 1-1V8c0-3.859-3.141-7-7-7H12c-3.86 0-7 3.141-7 7v4c0 .553.448 1 1 1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 42c-.553 0-1 .447-1 1v12H28c-.552 0-1 .447-1 1s.448 1 1 1h27c.553 0 1-.447 1-1V43c0-.553-.447-1-1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.828 25.172c-1.51-1.512-4.146-1.512-5.656 0L40.2 42.143c-.128.128-.219.289-.263.465l-1.414 5.656c-.086.341.015.701.263.949.189.189.445.293.707.293.081 0 .162-.01.242-.03l5.656-1.414c.176-.044.337-.135.465-.263L62.828 30.828c.756-.755 1.172-1.76 1.172-2.828s-.416-2.073-1.172-2.828zm-1.414 4.242L44.639 46.188l-3.771.943.943-3.771 14.653-14.654.707.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-.707-.707.707-.707c.756-.756 2.072-.756 2.828 0 .378.378.586.88.586 1.414s-.208 1.036-.586 1.414z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 48c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1 .449-1 1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 57c0-1.654-1.346-3-3-3s-3 1.346-3 3 1.346 3 3 3 3-1.346 3-3zm-4 0c0-.552.449-1 1-1s1 .448 1 1-.449 1-1 1-1-.448-1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 48c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.448-1-1s.449-1 1-1 1 .448 1 1-.449 1-1 1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 54c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3zm0-4c.551 0 1 .448 1 1s-.449 1-1 1-1-.448-1-1 .449-1 1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 62H19.896c3.659-2.303 6.104-6.367 6.104-11 0-7.168-5.832-13-13-13s-13 5.832-13 13 5.832 13 13 13h18c.552 0 1-.447 1-1s-.448-1-1-1zm-29-11c0-6.065 4.935-11 11-11s11 4.935 11 11-4.935 11-11 11-11-4.935-11-11z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 16H25c-.552 0-1 .447-1 1s.448 1 1 1h24c.553 0 1-.447 1-1s-.447-1-1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 20H19c-.552 0-1 .447-1 1s.448 1 1 1h30c.553 0 1-.447 1-1s-.447-1-1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 25c0-.553-.447-1-1-1H19c-.552 0-1 .447-1 1s.448 1 1 1h30c.553 0 1-.447 1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 29c0-.553-.447-1-1-1H19c-.552 0-1 .447-1 1s.448 1 1 1h22c.553 0 1-.447 1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 35c0-.553-.447-1-1-1H25c-.552 0-1 .447-1 1s.448 1 1 1h18c.553 0 1-.447 1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 39c0-.553-.447-1-1-1H25c-.552 0-1 .447-1 1s.448 1 1 1h14c.553 0 1-.447 1-1z",
    fill: "#c72538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 42c-.552 0-1 .447-1 1s.448 1 1 1h9c.553 0 1-.447 1-1s-.447-1-1-1z",
    fill: "#c72538"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinema);
export default __webpack_public_path__ + "static/media/cinema.e5eb42fa27008aef7d5b5b9c8e2fd039.svg";
export { ForwardRef as ReactComponent };